import { useEffect } from "react";
import PropTypes from "prop-types";

const NUMBER_OF_MILLISECONDS_IN_A_SECOND = 1000;

const canUseDOM = () => {
  return typeof window !== "undefined"
    && !!window.document
    && !!window.document.createElement;
};

export const ZendeskAPI = (...args) => {

  if (canUseDOM() && window.zE) {

    const globalContext = null;
    window.zE.apply(globalContext, args);
  } else {

    console.warn("Zendesk is not initialized yet, retrying...");
    setTimeout(() => ZendeskAPI(...args), NUMBER_OF_MILLISECONDS_IN_A_SECOND);
  }
};

const Zendesk = ({ zendeskKey, loadDeferred, onLoaded, ...extraParameters }) => {

  const onZendeskScriptLoaded = () => {

    if (typeof onLoaded === "function") {
      onLoaded();
    }
  };

  const insertScript = () => {
    const script = document.createElement("script");

    if (loadDeferred) {
      script.defer = true;
    } else {
      script.async = true;
    }

    script.id = "ze-snippet";
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
    script.addEventListener("load", onZendeskScriptLoaded);
    document.body.appendChild(script);
  };

  useEffect(() => {
    if (canUseDOM() && !window.zE) {
      insertScript();
      window.zESettings = extraParameters;
    }

    return () => {
      if (canUseDOM() && window.zE) {
        delete window.zE;
        delete window.zESettings;
      }
    };
  }, [zendeskKey, loadDeferred, onLoaded, extraParameters]);

  return null;
};

Zendesk.propTypes = {
  zendeskKey: PropTypes.string.isRequired,
  loadDeferred: PropTypes.bool,
  onLoaded: PropTypes.func,
};

export default Zendesk;
